<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap>
      <table cellpadding="0" cellspacing="0" id="associated">
        <tr>
          <th>
            Transaction ID
          </th>
          <th>
            Type
          </th>
          <th>
            Amount
          </th>
          <th>
            Status
          </th>
          <th>
            Authorized
          </th>
          <th>
            Settled
          </th>
          <th v-if="hasFapsMigration">
            Processor
          </th>
        </tr>
        <tr
          v-for="(row) in mergedTransactions"
          :key="row.id || row.tracking_id"
        >
          <td>
            {{ row.tracking_id }}
          </td>
          <td class="text-capitalize">
            {{ row.request_type }}
          </td>
          <td>
            <template v-if="row.request_type === 'credit' || row.request_type === 'achcredit' || row.request_type === 'void' || row.request_type === 'achvoid'">
              ({{ money((row.total_amount - row.fee_amount) / 100) }})
            </template>
            <!--
            <template v-else-if="row.request_type === 'void' || row.request_type === 'achvoid'">
              ({{ money(row.parent_total_amount / 100) }})
            </template>
            -->
            <template v-else>
              {{ money((row.total_amount - row.fee_amount) / 100) }}
            </template>
          </td>
          <td>
            {{ row.response_code === '000' ? 'Approved' : 'Declined' }}
          </td>
          <td>
            {{ datetime(row.authorized) }}
          </td>
          <td>
            {{ datetime(row.settled) }}
          </td>
          <td v-if="hasFapsMigration">
            <v-chip small outline :color="row.processor === 'FAPS' ? 'orange' : 'primary'">{{ row.processor || 'PNX' }}</v-chip>
          </td>
        </tr>
        <tr v-if="!hasFapsMigration && transaction.parent_tracking_id">
          <td>
            {{ transaction.parent_tracking_id }}
          </td>
          <td class="text-capitalize">
            {{ transaction.parent_request_type }}
          </td>
          <td>
            <template v-if="transaction.parent_request_type === 'credit' || transaction.parent_request_type === 'achcredit' || transaction.parent_request_type === 'void' || transaction.parent_request_type === 'achvoid'">
              ({{ money((transaction.parent_total_amount - transaction.parent_fee_amount) / 100) }})
            </template>
            <template v-else>
              {{ money((transaction.parent_total_amount - transaction.parent_fee_amount) / 100) }}
            </template>
          </td>
          <td>
            {{ transaction.parent_response_code === '000' ? 'Approved' : 'Declined' }}
          </td>
          <td>
            {{ datetime(transaction.parent_authorized) }}
          </td>
          <td>
            {{ datetime(transaction.parent_settled) }}
          </td>
        </tr>
        <tr v-else-if="!hasFapsMigration">
          <td>
            {{ transaction.tracking_id }}
          </td>
          <td class="text-capitalize">
            {{ transaction.request_type }}
          </td>
          <td>
            <template v-if="transaction.request_type === 'credit' || transaction.request_type === 'achcredit' || transaction.request_type === 'void' || transaction.request_type === 'achvoid'">
              ({{ money((transaction.total_amount - transaction.fee_amount) / 100) }})
            </template>
            <template v-else>
              {{ money((transaction.total_amount - transaction.fee_amount) / 100) }}
            </template>
          </td>
          <td>
            {{ transaction.response_code === '000' ? 'Approved' : 'Declined' }}
          </td>
          <td>
            {{ datetime(transaction.authorized) }}
          </td>
          <td>
            {{ datetime(transaction.settled) }}
          </td>
        </tr>
      </table>
    </v-layout>
  </v-container>
</template>

<script>
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      enabled: false
    }
  },

  props: {
    transaction: Object,
    fapsTransactions: {
      type: Array,
      default: function () { return [] }
    },
    paymentHistory: {
      type: Array,
      default: function () { return [] }
    }
  },

  computed: {
    hasFapsMigration () {
      if (this.fapsTransactions && this.fapsTransactions.length > 0) return true
      let customData = this.transaction.custom
      if (typeof customData === 'string') {
        try { customData = JSON.parse(customData) } catch (e) { return false }
      }
      return customData && !!customData.migrated_from_transaction_id
    },

    mergedTransactions () {
      let associated = this.transaction.associatedTransactions || []
      let paymentTypes = ['sale', 'credit', 'ach', 'achcredit', 'void', 'achvoid']
      let merged = []
      let seenTrackingIds = new Set()
      let seenIds = new Set()
      let fapsAddedTrackingIds = new Set()

      if (this.fapsTransactions && this.fapsTransactions.length) {
        this.fapsTransactions.forEach(tran => {
          if (!paymentTypes.includes(tran.request_type)) return
          if (tran.associatedTransactions && tran.associatedTransactions.length) {
            tran.associatedTransactions.forEach(child => {
              if (paymentTypes.includes(child.request_type)) {
                let key = child.id || child.tracking_id
                if (key && seenIds.has(key)) return
                if (child.id) seenIds.add(child.id)
                if (child.tracking_id) {
                  seenTrackingIds.add(child.tracking_id)
                  fapsAddedTrackingIds.add(child.tracking_id)
                }
                merged.push(Object.assign({}, child, {
                  processor: child.processor_name === 'fpg' ? 'FAPS' : 'PNX'
                }))
              }
            })
          }
          if (tran.authorized) {
            let key = tran.id || tran.tracking_id
            if (key && seenIds.has(key)) return
            if (tran.id) seenIds.add(tran.id)
            if (tran.tracking_id) {
              seenTrackingIds.add(tran.tracking_id)
              fapsAddedTrackingIds.add(tran.tracking_id)
            }
            merged.push(Object.assign({}, tran, {
              processor: tran.processor_name === 'fpg' ? 'FAPS' : 'PNX'
            }))
          }
        })
      }

      associated.forEach(row => {
        if (row.request_type === 'modify' || row.authorized === null) return
        if (row.tracking_id && fapsAddedTrackingIds.has(row.tracking_id)) return
        if (row.id && seenIds.has(row.id)) return
        if (row.tracking_id && seenTrackingIds.has(row.tracking_id)) return
        if (row.id) seenIds.add(row.id)
        if (row.tracking_id) seenTrackingIds.add(row.tracking_id)
        let proc = (this.hasFapsMigration && row.processor_id !== this.transaction.processor_id) ? 'FAPS' : 'PNX'
        merged.push(Object.assign({}, row, { processor: proc }))
      })

      if (this.paymentHistory && this.paymentHistory.length) {
        this.paymentHistory.forEach(row => {
          if (!paymentTypes.includes(row.request_type)) return
          if (row.tracking_id && fapsAddedTrackingIds.has(row.tracking_id)) return
          if (row.id && seenIds.has(row.id)) return
          if (row.tracking_id && seenTrackingIds.has(row.tracking_id)) return
          if (row.id) seenIds.add(row.id)
          if (row.tracking_id) seenTrackingIds.add(row.tracking_id)
          let proc = (this.hasFapsMigration && row.processor_id !== this.transaction.processor_id) ? 'FAPS' : 'PNX'
          merged.push(Object.assign({}, row, { processor: proc }))
        })
      }

      return merged
    }
  },

  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transactions/Associated.vue